<!-- Modal Header -->
<div class="header-modal mb-0">
  <div class="main-title w-100 mt-0 mb-0">
    <div class="header">Report of Deficiencies History</div>
  </div>
  <span class="close-dialog" (click)="noDelete()">
    <i class="material-icons">close</i>
  </span>
</div>

<!-- Content if files exist -->
<div mat-dialog-content *ngIf="latestFile || (previousFiles?.length > 0)">
  <!-- Latest Report -->
  <div class="mb-20" *ngIf="latestFile">
    <div class="sub-header">Latest Report</div>
    <div class="report-row">
      <img src="assets/icons/pdf.svg" />
      <a (click)="openFile(latestFile)">Report of Deficiencies</a>
      <span class="updated">Last Updated: {{ latestFile?.updatedAt | date: 'MM/dd/yyyy' }}</span>
    </div>
  </div>

  <!-- Previous Reports -->
  <div *ngIf="previousFiles?.length > 0">
    <hr/>
    <div class="sub-header">Previous Reports</div>
    <div class="report-row" *ngFor="let file of previousFiles">
      <img src="assets/icons/pdf.svg" />
      <a (click)="openFile(file)">Report of Deficiencies</a>
      <span class="updated">Last Updated: {{ file.updatedAt | date: 'MM/dd/yyyy' }}</span>
    </div>
  </div>
</div>

<!-- Message if no reports exist -->
<div mat-dialog-content *ngIf="!latestFile && (!previousFiles || previousFiles.length === 0)">
  <p>No reports available.</p>
</div>
